import { Methods as NearAreaAPI } from '@doda/api-client/aspida/api/v1/jobs/neararea';
import { ACCETABLE_SORT_VALUES } from '@doda/common/src/constants/accetableRequestValues';
import { AppQueryParams } from '@doda/common/src/constants/queryParams';
import { hasOnlyOneElement } from '@doda/common/src/utils/typeGuard';
import { ValueOf } from '@doda/common/src/utils/typeUtil';
import { AREA_QUERIES, areaQueryMap } from '../constants/nearArea';

const DISPLAY_NUMBER = 50;

export type NearAreaQuery = NonNullable<NearAreaAPI['get']['query']>;

/**
 * 近隣エリア一覧APIリクエストパラメータを生成
 */
export const createNearAreaJobListRequestParams = (
  query: AppQueryParams,
  offsetValue?: number
): NearAreaQuery => {
  const requestParams: NearAreaQuery = {};

  if (query.pr && query.pr.length === 1)
    requestParams.prefectureId = query.pr.join();
  if (query.ci && query.ci.length === 1) requestParams.cityId = query.ci.join();
  if (query.wa && query.wa.length === 1) requestParams.wardId = query.wa.join();
  if (query.st && query.st.length === 1)
    requestParams.stationId = query.st.join();

  if (query.baseArea) {
    // baseAreaが存在する場合は、エリアクエリをbaseAreaの値で書き換える
    const newAareaQuery = getNewAreaQuery(query);
    if (newAareaQuery) requestParams[newAareaQuery] = query.baseArea;
  }

  if (query.ds) requestParams.sort = ACCETABLE_SORT_VALUES[query.ds];

  requestParams.offset =
    offsetValue ?? ((Number(query.page) || 1) - 1) * DISPLAY_NUMBER;

  return requestParams;
};

/** 検索のベースとなったクエリに対応する新規のエリアクエリを返す */
const getNewAreaQuery = (
  params: AppQueryParams
): ValueOf<typeof areaQueryMap> | null => {
  const queriesWithValue = AREA_QUERIES.filter((query) => params[query]);
  return hasOnlyOneElement(queriesWithValue)
    ? areaQueryMap[queriesWithValue[0]]
    : null;
};
